<template>
  <div>
    <!--导航栏  @click-left="onClickLeft"  left-arrow left-text="返回" start-->
    <van-nav-bar
        title="选择商户"

        right-text="添加商户"

        @click-right="onClickRight"

        fixed
    />
    <!--导航栏 end-->
    <van-list
        class="list"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
    >

      <van-cell @click="onSubmit(admin.merchant_num)" size="large" v-for="(admin,index) in list" :key="index" :title="admin.bse_lice_nm" is-link :value="admin.merchant_num" />
    </van-list>

  </div>
</template>

<script>


import {Notify, Toast} from "vant";

export default {
  name: "MerchantImpower", //选择商户登录
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      page:1,
      limit:2,
      ta:"222"
    };
  },
  // 组件内路由--进入组件时
  beforeRouteEnter(to, from, next) {
    window.document.body.style.backgroundColor = '#f5f5f5';
    next();
  },
  // 组件内路由--离开组件时
  beforeRouteLeave(to, from, next) {
    window.document.body.style.backgroundColor = '';
    next();
  },
  mounted() {
  this. GetQueryString("openid")
    },
  methods: {
    // 左侧返回
    // onClickLeft() {
    //   this.$router.push("/");
    //   // window.history.go(-1)
    // },
    onClickRight(){
      this.$router.push("/MerchantLogin");
        // Toast('添加商户');
    },

    GetQueryString(name){
        var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
        var r = window.location.search.substr(1).match(reg);
        if(r!=null){

          window.localStorage.setItem("openid",unescape(r[2]))
          return  unescape(r[2]);
        }

        return null;
    },



    //点击商户登录
    onSubmit(e){
      window.sessionStorage.setItem("tag",this.ta)
      var toast = Toast.loading({
        duration: 0,
        message: '登录中',
        forbidClick: true,
        loadingType: 'spinner',
      });
      // console.log('submit', values);
      this.$http.get('/wechat/login/login', {
        params: {
          openid:window.localStorage.getItem("openid"),
          account:e,
          type:"merchant"
        }
      }).then(response => {
        toast.clear();
        console.log(response.data);
        if ( response.data.code== 200) {
          window.sessionStorage.setItem("token",response.data.data.token)
          window.sessionStorage.setItem("commercialId",response.data.data.merchant_id)
           window.sessionStorage.setItem("open_coupon",response.data.data.open_coupon)
          // window.sessionStorage.setItem("username",this.username)

          this.$router.push("/MerchantHomepage");

          // VueCookie.set('salesmanInfo', response.data.data, 360000);
          // window.location.href = that.redirect;

        }else{
          Notify({type: 'danger', message: response.data.msg});
        }
      })

    },


    onLoad() {


      var that = this;
      // var salesmanInfo = VueCookie.get("salesmanInfo");
      this.$http.get('/wechat/login/lst', {
        params: {
          // id: salesmanInfo.id,
          openid:window.localStorage.getItem("openid"),
          page: that.page,
          limit:that.limit,
          type:"merchant"
        }
      }).then(response => {

        // 加载状态结束
        that.loading = false;
        // console.log(response.data.data)
        // that.list = that.list.concat(response.data)
        // console.log(that.list)
        // 页码

        // this.finished = true;
        if (response.data.data.length) {
          that.list.push(...response.data.data);
          that.finished = false;
          that.page++;
        }else
          that.finished = true;

      });
    },



  },
}
</script>

<style >
.list{
  margin-top: 1rem;
}
</style>
